// ✅ src/Redux/thunks/personalHistoryThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosMedical } from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";
import { resolveMedicalScope } from "./medicalScope";

// 🧩 Aide debug propre
const dbg = (label, x) => {
  try {
  } catch {
  }
};

/* =========================================================
   🧠 PERSONAL HISTORY THUNKS
   ========================================================= */

/** 🔍 GET - Timeline personnelle (Lifestyle factors: Smoking, Alcohol, Sport) */
export const fetchPersonalHistoryByUserId = createAsyncThunk(
  "personalHistory/fetchByUserId",
  async (target, { rejectWithValue, getState }) => {
    try {
      const { userId: scopedUserId, headers } = resolveMedicalScope(
        getState(),
        target
      );
      const url = ENDPOINTS.MEDICAL.PERSONAL_HISTORY_TIMELINE(scopedUserId);
      dbg("GET", { url, headers });
      const { data } = await axiosMedical.get(url, { headers });
      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err?.message);
    }
  }
);

/** ➕ CREATE - Ajouter un facteur personnel (Smoking, Alcohol, Sport) */
export const addPersonalHistory = createAsyncThunk(
  "personalHistory/add",
  async ({ userId, values }, { rejectWithValue, getState }) => {
    try {
      const { userId: scopedUserId, headers } = resolveMedicalScope(
        getState(),
        userId
      );
      const body = { type: values.type, value: values.value };
      if (values.status !== undefined) body.status = values.status;
      if (values.isActive !== undefined) body.isActive = values.isActive;
      const url = ENDPOINTS.MEDICAL.PERSONAL_HISTORY(scopedUserId);
      dbg("POST", { url, body, headers });

      const { data } = await axiosMedical.post(url, body, {
        headers: { "Content-Type": "application/json", ...headers },
      });

      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err?.message);
    }
  }
);

/** 🔁 UPDATE - Modifier un facteur personnel (ex: changer le niveau) */
export const updatePersonalHistory = createAsyncThunk(
  "personalHistory/update",
  async ({ userId, id, values }, { rejectWithValue, getState }) => {
    try {
      const { userId: scopedUserId, headers } = resolveMedicalScope(
        getState(),
        userId
      );
      const body = {};
      if (values.value !== undefined) body.value = values.value;
      if (values.status !== undefined) body.status = values.status;
      if (values.isActive !== undefined) body.isActive = values.isActive;
      const url = ENDPOINTS.MEDICAL.UPDATE_PERSONAL_HISTORY(scopedUserId, id);
      dbg("PUT", { url, body, headers });

      const { data } = await axiosMedical.put(url, body, {
        headers: { "Content-Type": "application/json", ...headers },
      });

      return data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err?.message);
    }
  }
);

/** 🗑️ DELETE - Supprimer un facteur personnel (si désactivé par toggle OFF) */
export const removePersonalHistory = createAsyncThunk(
  "personalHistory/delete",
  async ({ userId, id }, { rejectWithValue, getState }) => {
    try {
      const { userId: scopedUserId, headers } = resolveMedicalScope(
        getState(),
        userId
      );
      const url = ENDPOINTS.MEDICAL.DELETE_PERSONAL_HISTORY(scopedUserId, id);
      dbg("DELETE", { url, headers });

      const { data } = await axiosMedical.delete(url, { headers });
      return { id, ...data };
    } catch (err) {
      return rejectWithValue(err?.response?.data || err?.message);
    }
  }
);
